import { rem } from 'polished'
import styled, { keyframes, useTheme } from 'styled-components'

import Caption from 'LuxKit/Typography/Caption'

export const TEARDROP_PIN_WIDTH = 32
export const TEARDROP_PIN_HEIGHT = 43

const StyledSvg = styled.svg`
  pointer-events: none;
  color: ${(props) => props.theme.palette.brand.primary.normal};
  overflow: visible;

  & > path {
    pointer-events: all;
    cursor: pointer;
  }
`

const Pop = keyframes`
  0% {
    transform: scale(1);
    }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`

const Container = styled.div`
  position: relative;
  width: auto;
  height: auto;

  animation: ${Pop} 0.5s ease;
`

const CaptionText = styled(Caption)`
  color: ${(props) => props.theme.palette.messaging.favourite.normalForeground};
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff;
`

const CaptionTextContainer = styled.div`
  position: absolute;
  top: ${rem(-26)};
  left: 50%;
  transform: translateX(-50%);
  margin: auto;
  white-space: nowrap;
  text-align: center;
  z-index: 9999;
`

interface Props {
  text: string
}

function MapSelectItemPin({ text }: Props) {
  const theme = useTheme()
  return (
    <Container>
      <StyledSvg
        width={TEARDROP_PIN_WIDTH}
        height={TEARDROP_PIN_WIDTH}
        viewBox="0 0 32 43"
      >
        <mask
          id="path-1-outside-1_4248_8059"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="43"
          fill="black"
        >
          <rect fill="white" width="32" height="43" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.3859 26.7186C28.4451 24.0269 30.3755 20.0828 30.3755 15.6877C30.3755 7.57592 23.7995 1 15.6877 1C7.57592 1 1 7.57592 1 15.6877C1 20.1224 2.96534 24.098 6.07254 26.7911C12.0166 32.5791 14.5022 38.3376 15.3909 40.9315C15.5025 41.2573 16.1153 41.2531 16.2223 40.9258C17.075 38.3182 19.4861 32.5267 25.3859 26.7186Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.3859 26.7186C28.4451 24.0269 30.3755 20.0828 30.3755 15.6877C30.3755 7.57592 23.7995 1 15.6877 1C7.57592 1 1 7.57592 1 15.6877C1 20.1224 2.96534 24.098 6.07254 26.7911C12.0166 32.5791 14.5022 38.3376 15.3909 40.9315C15.5025 41.2573 16.1153 41.2531 16.2223 40.9258C17.075 38.3182 19.4861 32.5267 25.3859 26.7186Z"
          fill={theme.palette.messaging.favourite.normalForeground}
        />
        <path
          d="M25.3859 26.7186L24.7253 25.9678L24.7043 25.9863L24.6844 26.006L25.3859 26.7186ZM6.07254 26.7911L6.77019 26.0746L6.74941 26.0544L6.7275 26.0354L6.07254 26.7911ZM15.3909 40.9315L16.337 40.6074L15.3909 40.9315ZM16.2223 40.9258L17.1728 41.2366L16.2223 40.9258ZM29.3755 15.6877C29.3755 19.7834 27.5779 23.458 24.7253 25.9678L26.0465 27.4694C29.3123 24.5959 31.3755 20.3821 31.3755 15.6877H29.3755ZM15.6877 2C23.2473 2 29.3755 8.12821 29.3755 15.6877H31.3755C31.3755 7.02364 24.3518 0 15.6877 0V2ZM2 15.6877C2 8.12821 8.12821 2 15.6877 2V0C7.02364 0 0 7.02364 0 15.6877H2ZM6.7275 26.0354C3.83012 23.5242 2 19.8202 2 15.6877H0C0 20.4245 2.10057 24.6718 5.41759 27.5468L6.7275 26.0354ZM16.337 40.6074C15.411 37.9048 12.8533 31.9982 6.77019 26.0746L5.3749 27.5075C11.1798 33.16 13.5934 38.7703 14.4449 41.2557L16.337 40.6074ZM15.2718 40.615C15.3379 40.4129 15.4754 40.2931 15.5765 40.2368C15.6703 40.1846 15.75 40.1739 15.8014 40.1736C15.8528 40.1732 15.9327 40.1828 16.0271 40.2337C16.129 40.2886 16.2681 40.4063 16.337 40.6074L14.4449 41.2557C14.6997 41.9993 15.4232 42.1762 15.8153 42.1735C16.2073 42.1708 16.9284 41.9839 17.1728 41.2366L15.2718 40.615ZM24.6844 26.006C18.6432 31.9532 16.1606 37.8969 15.2718 40.615L17.1728 41.2366C17.9893 38.7394 20.3291 33.1001 26.0875 27.4312L24.6844 26.006Z"
          fill={theme.palette.messaging.favourite.darkForeground}
          mask="url(#path-1-outside-1_4248_8059)"
        />
        <circle
          cx="15.5"
          cy="15.5"
          r="6.5"
          fill={theme.palette.messaging.favourite.darkForeground}
        />
      </StyledSvg>
      <CaptionTextContainer>
        <CaptionText variant="large" weight="bold">
          {text}
        </CaptionText>
      </CaptionTextContainer>
    </Container>
  )
}

export default MapSelectItemPin
